import { FontOption, FontSizeOption } from '../types';

// API端点
export const API_ENDPOINTS = {
  UPLOAD: '/api/upload',
  GENERATE_PDF: '/api/pdf/generate-pdf',
  PDF_FILES: '/api/pdf/pdf-files',
  DOWNLOAD_PDF: '/api/pdf/download-pdf',
  TEMPLATES: '/api/templates',  // 新增模板端点
  HEALTH: '/api/health'
} as const;

// 佈局選項
export const LAYOUT_OPTIONS = [
  { label: '左對齊', value: 'left' as const },
  { label: '居中對齊', value: 'center' as const },
  { label: '右對齊', value: 'right' as const }
];

// 字体大小选项
export const FONT_SIZE_OPTIONS: FontSizeOption[] = [
  { label: '12px', value: '12' },
  { label: '14px', value: '14' },
  { label: '16px', value: '16' },
  { label: '18px', value: '18' },
  { label: '20px', value: '20' },
  { label: '24px', value: '24' }
];

// 字體類型選項
export const FONT_FAMILY_OPTIONS: FontOption[] = [
  { label: 'Arial', value: 'Arial, sans-serif' },
  { label: 'Times New Roman', value: '"Times New Roman", serif' },
  { label: 'Courier New', value: '"Courier New", monospace' },
  { label: '微軟雅黑', value: '"Microsoft YaHei", sans-serif' },
  { label: '宋體', value: '"SimSun", serif' },
  { label: '黑體', value: '"SimHei", sans-serif' }
];

// 文件上传限制
export const UPLOAD_CONSTRAINTS = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_FILES: 10,
  ACCEPTED_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'] as const,
  ACCEPTED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.webp'] as const
} as const;

// 表单验证规则
export const VALIDATION_RULES = {
  TITLE_MAX_LENGTH: 100,
  SUBTITLE_MAX_LENGTH: 200,
  AUTHOR_MAX_LENGTH: 50,
  CONTENT_MAX_LENGTH: 10000
} as const;

// 默认表单数据
export const DEFAULT_FORM_DATA = {
  title: '',
  subtitle: '',
  content: '',
  author: '',
  date: new Date().toISOString().split('T')[0],
  layout: 'left' as const,
  fontSize: '14',
  fontFamily: 'Arial, sans-serif'
} as const;

// 錯誤消息
export const ERROR_MESSAGES = {
  NETWORK_ERROR: '網絡連接失敗，請檢查網絡後重試',
  UPLOAD_FAILED: '文件上傳失敗，請重試',
  PDF_GENERATION_FAILED: 'PDF生成失敗，請重試',
  FILE_TOO_LARGE: '文件大小超過限制（最大5MB）',
  INVALID_FILE_TYPE: '不支持的文件類型，請選擇圖片文件',
  TITLE_REQUIRED: '請填寫文檔標題',
  FETCH_FILES_FAILED: '獲取文件列表失敗',
  DELETE_FILE_FAILED: '刪除文件失敗',

  // 新增模板相關錯誤消息
  TEMPLATE_CREATE_FAILED: '創建模板失敗',
  FETCH_TEMPLATES_FAILED: '獲取模板列表失敗',
  FETCH_TEMPLATE_FAILED: '獲取模板詳情失敗',
  UPDATE_TEMPLATE_FAILED: '更新模板失敗',
  DELETE_TEMPLATE_FAILED: '刪除模板失敗',
  GENERATE_PREVIEW_FAILED: '生成模板預覽失敗'
} as const;

// 成功消息
export const SUCCESS_MESSAGES = {
  PDF_GENERATED: 'PDF生成成功！',
  FILES_UPLOADED: '文件上傳成功！',
  FILE_DELETED: '文件刪除成功！',
  
  // 新增模板相關成功消息
  TEMPLATE_CREATED: '模板創建成功！',
  TEMPLATE_UPDATED: '模板更新成功！',
  TEMPLATE_DELETED: '模板刪除成功！'
} as const;

// 應用信息
export const APP_INFO = {
  NAME: 'PDF Maker',
  VERSION: '1.0.0',
  DESCRIPTION: '創建精美的PDF文檔，簡單快捷',
  COPYRIGHT: '© 2024 PDF Maker. 讓文檔創建變得簡單美好.'
} as const;
